import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import {
  PaymentLinksReportFilters,
  PaymentLinksReportPayload,
  createEmptyPaymentLinksReportPayload,
} from '../models/payment-links-report.models';

interface ApiEnvelope<T> {
  status: string;
  message?: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class PaymentLinksReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  getReport(params: PaymentLinksReportFilters = {}): Observable<PaymentLinksReportPayload> {
    return this.http
      .get<ApiEnvelope<PaymentLinksReportPayload>>(`${this.rootUrl}/api/v1/reports/payment-links`, {
        params: this.buildParams(params as Record<string, unknown>),
      })
      .pipe(map((response) => response?.data ?? createEmptyPaymentLinksReportPayload()));
  }

  private buildParams(params: Record<string, unknown>): HttpParams {
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }

      httpParams = httpParams.set(key, String(value));
    });

    return httpParams;
  }
}
